/// <reference types="vite-plugin-svgr/client" />
import classNames from "classnames";
import React, { FC, useEffect, useState } from "react";

import * as chatbot from "../chatbot";
import Translated from "../infrastructure/components/Translated";
import styles from "./Chatbot.module.less";
import ChatbotLogo from "./Chatbot_Posten.svg?react";

const Chatbot: FC = (): React.ReactElement => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const onKindlyUiEvent = (kindlyUiEvent: KindlyUiEvent) => {
    const eventType = kindlyUiEvent?.detail?.type;
    if (!eventType) {
      return;
    }
    if (eventType === "end-chat" || eventType === "close-chatbubble") {
      setIsChatOpen(false);
    }
    if (eventType === "open-chatbubble") {
      setIsChatOpen(true);
    }
  };

  useEffect(() => {
    document.addEventListener("kindly:ui", onKindlyUiEvent);

    return () => {
      document.removeEventListener("kindly:ui", onKindlyUiEvent);
    };
  }, []);

  return (
    <div
      role="complementary"
      id="chatbox"
      className={classNames(styles.chatbot, isChatOpen && styles.chatbotOpen)}
    >
      <ChatbotLogo
        className={styles.chatbotImage}
        aria-labelledby="chatbotTitle"
        onClick={chatbot.openKindlyChat}
      />
      <title id="chatbotTitle">
        <Translated textKey={"chatbot.alt"} />
      </title>
    </div>
  );
};

export default Chatbot;
